import React, { useEffect, useRef } from "react";
import { observer } from "mobx-react";
import { Grid } from "@mui/material";
import { useStore } from "utils/useStore";
import { AgentAvatar } from "../Branding/AgentAvatar";
import AgentStore from "../Stores/AgentStore";
import KboUserAgreementStore from "../Stores/KboUserAgreementStore";
import { KboUserAgreementCard } from "./KboUserAgreementCard";
import { KboUserAgreementCollapsedBanner } from "./KboUserAgreementCollapsedBanner";

/**
 * The KBo User Agreement as a message from KBo, shown in the chat until the user
 * accepts it.
 */
export const KboUserAgreementThreadItem = observer(
    ({ maxWidth }: { maxWidth: string }) => {
        const agentStore = useStore(AgentStore);
        const store = useStore(KboUserAgreementStore);
        const itemRef = useRef<HTMLDivElement>(null);

        // Bring it into view whenever something asks for the agreement.
        useEffect(() => {
            if (store.scrollRequest === 0) return;
            itemRef.current?.scrollIntoView({
                behavior: "smooth",
                block: "nearest",
            });
        }, [store.scrollRequest]);

        if (!agentStore.isKboInteractionLocked || !store.agreement) return null;

        return (
            <Grid
                container
                item
                ref={itemRef}
                id="kbo-user-agreement"
                flexWrap="nowrap"
                alignItems="flex-start"
                gap={1}
                alignSelf="self-start"
                width={maxWidth}
                maxWidth="100%"
            >
                <Grid item>
                    <AgentAvatar />
                </Grid>
                <Grid item flex={1} minWidth={0}>
                    {store.isCollapsed ? (
                        <KboUserAgreementCollapsedBanner />
                    ) : (
                        <KboUserAgreementCard agreement={store.agreement} />
                    )}
                </Grid>
            </Grid>
        );
    },
);
